import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.users.deleteUser],
    mutationFn: async (userId: string): Promise<void> => {
      await XHRAuthorizedClient.delete<ApiResponse<void>>(
        ENDPOINTS.users.delete(userId)
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('유저 삭제 오류:', error);
    },
  });
};
